export default {
  computed: {
    isSmallScreen() {
      return this.$store.getters["getIsSmallScreen"];
    }
  }
};
